export default "__VITE_ASSET__Buu5EQdP__"